import React from 'react';
import PropTypes from 'prop-types';
import BackHistory from '../../Navigation/Back/BackHistoryContainer';
import AdvForm from '../../../CommonComponents/AdvForm';
import ProgressBar from '../../ProgressBar/ProgressBarContainer';
import workflowAnalyticsEvents from '../../AnalyticsWorkflow/AnalyticsWorkflow';
import {
  createCustomPropType,
  isAnything,
  isNonEmptyString,
} from '../../../../js/app/react/validators';
import XMobileNavigation from '../../XMobileNavigation/XMobileNavigationContainer';
import { endOfWorkflowsRedirectTo } from '../AdvWorkflowHelpers';
import { EXTERNAL_HOST } from '../../../ConsumerArea/ConsumerAreaConstants';
import { WORKFLOW_ID as DECUMULATION_WORKFLOW_ID } from '../../DecumulationWorkflow/DecumulationWorkflow.constants';

const AdvWorkflowSummaryView = ({
  workflowId,
  currentClientId,
  isInSummary,
  itemList,
  summaryJump,
  hasTakeMeToPlan,
  canGoToPlan,
  lastStepResponse,
  hasAddAnotherGoal,
  onFinish,
  outputFunction,
  finishButtonText,
  goToAddAnotherGoal,
  currentClient,
  externalHost,
}) => (
  <section
    className={`adv-workflow-container-ie11${
      !isInSummary || itemList.length <= 0 ? ' adv-workflow-section-hidden' : ''
    }`}
  >
    <div className="adv-workflow-container-outer">
      {isInSummary && <ProgressBar workflowId={workflowId} />}
      {isInSummary && <XMobileNavigation workflowId={workflowId} />}
      <div className="adv-workflow-container-inner">
        <div className="adv-workflow-content generic-workflow">
          <div className="step">
            <h1 className="adv-workflow-heading">Please review the information below</h1>
            <BackHistory workflowId={workflowId} />
            <div className="adv-workflow-crud-widget">
              <div className="adv-workflow-crud-populated">
                <ul className="adv-workflow-crud-populated-ul">
                  {itemList.map(({ iterator, title, details, readOnly }) => (
                    <li className="adv-workflow-crud-populated-li">
                      {readOnly ? (
                        <>
                          <div className="adv-workflow-crud-populated-name-2">Proposal Account</div>
                          <div className="adv-workflow-crud-populated-value-2">{title}</div>
                        </>
                      ) : (
                        <>
                          <div className="adv-workflow-crud-populated-name-2">{title}</div>
                          <div className="adv-workflow-crud-populated-value-2">{details}</div>
                        </>
                      )}
                      {!readOnly && (
                        <div className="adv-workflow-crud-populated-actions-2">
                          <button
                            type="button"
                            aria-label="edit"
                            className="adv-workflow-crud-populated-action"
                            onClick={() => {
                              workflowAnalyticsEvents(workflowId, 'summary_edit_selected', {
                                title,
                              });
                              summaryJump(workflowId, currentClientId, iterator);
                            }}
                          >
                            <i className="adv-workflow-crud-populated-action-i far fa-edit" />
                          </button>
                        </div>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <AdvForm className="AccountAddEditView">
              <div className="footer">
                {(hasTakeMeToPlan || canGoToPlan) && lastStepResponse !== null && (
                  <button
                    data-testid={workflowId}
                    type="button"
                    className={
                      hasAddAnotherGoal && workflowId !== DECUMULATION_WORKFLOW_ID
                        ? 'adv-workflow-navigation-cancel-button'
                        : 'adv-workflow-navigation-next-save-button'
                    }
                    onClick={() => {
                      workflowAnalyticsEvents(workflowId, 'summary_to_plan_selected');

                      if (externalHost === EXTERNAL_HOST.ELEMENT) {
                        endOfWorkflowsRedirectTo('GoalsSummary', {
                          clientId: currentClientId,
                        });
                      } else {
                        outputFunction(lastStepResponse);
                      }
                    }}
                  >
                    {workflowId === DECUMULATION_WORKFLOW_ID
                      ? 'Take me to my results'
                      : 'Take me to my plan'}
                  </button>
                )}
                {!(hasTakeMeToPlan || canGoToPlan) && lastStepResponse !== null && (
                  <button
                    type="button"
                    className={
                      hasAddAnotherGoal
                        ? 'adv-workflow-navigation-cancel-button'
                        : 'adv-workflow-navigation-next-save-button'
                    }
                    onClick={onFinish(
                      currentClientId,
                      hasTakeMeToPlan || canGoToPlan,
                      currentClient,
                    )}
                  >
                    {finishButtonText}
                  </button>
                )}
                {hasAddAnotherGoal && workflowId !== DECUMULATION_WORKFLOW_ID && (
                  <button
                    type="button"
                    className="adv-workflow-navigation-next-save-button"
                    onClick={goToAddAnotherGoal(currentClientId)}
                  >
                    Add another goal
                  </button>
                )}
              </div>
            </AdvForm>
          </div>
        </div>
      </div>
    </div>
  </section>
);
AdvWorkflowSummaryView.defaultProps = {
  currentClientId: null,
};
AdvWorkflowSummaryView.propTypes = {
  canGoToPlan: PropTypes.bool.isRequired,
  finishButtonText: PropTypes.string.isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  currentClientId: createCustomPropType(isAnything),
  iterator: PropTypes.shape({}).isRequired,
  outputFunction: PropTypes.func.isRequired,
  itemList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  summaryJump: PropTypes.func.isRequired,
  isInSummary: PropTypes.bool.isRequired,
  hasTakeMeToPlan: PropTypes.bool.isRequired,
  hasAddAnotherGoal: PropTypes.bool.isRequired,
  onFinish: PropTypes.func.isRequired,
  goToAddAnotherGoal: PropTypes.func.isRequired,
  lastStepResponse: PropTypes.shape({}).isRequired,
  externalHost: PropTypes.string.isRequired,
  currentClient: PropTypes.string.isRequired,
};

export default AdvWorkflowSummaryView;
